/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 *
 * Swedish (Sweden): sv-se
 */

/**
 * Translation file for sv-SE locale
 *
 * @file sv.js
 * @author Mohamed yasar arabath M
 */

const sv = {
  'popularChannelSlider.allChannels': 'Alla kanaler',
  'popularChannelSlider.recommended': 'Rekommenderas',
  'hero.myetextbook.link': 'bibliotek',
  'hero.myetextbook.text': 'Inte den rätta titeln? Få åtkomst till din e-lärobok',
  'hero.etextfeaturestitle': 'Hitta studiematerial i din e-lärobok',
  'hero.etextfeaturesdescription': 'Din e-lärobok innehåller studiematerial som är utformat för att hjälpa dig att lyckas. Studera med flashkort och mycket mer direkt i din e-lärobok.',
  'aichat.title1': 'Få AI-driven hjälp om något relaterat till denna e-lärobok.',
  'aichat.chatDesc1': 'Skriv in en fråga för att komma igång',
  'subscriptiontext.isSubscribed': 'Del av din prenumeration',
  'subscriptiontext.nonSubscriber': 'Uppgradera för fullständig åtkomst',
  'topicConatiner.otherHeader': 'Relaterade videoklipp och övning',
  'topicConatiner.exactLiteHeader': 'Relaterade begrepp och övning',
  'moremenu.downloadApp': 'Ladda ner appen',
  'moremenu.downloadAppAlreadyDownload': '%Click here% för att ladda ner appen på en annan enhet och logga in automatiskt eller för att använda din unika QR-kod för att logga in säkert på den app du redan har installerat.',
  'moremenu.downloadAppNotDownload': '%Click here% för att ladda ner appen och logga in säkert med din unika QR-kod',
  'channel.noBundletitle': 'Använd studieförberedelse för dina relaterade och andra kurser',
  'onboard.studyPlan': 'Anpassad studieplan skapad!',
  'onboard.addCourseAnother': 'Vill du lägga till en till kurs?',
  'onboard.purchase': 'Jag behöver köpa en Pearson e-lärobok',
  'onboard.addCourseWithoutEtext': 'Lägg till kurs med hjälp av Studieförberedelse',
  'onboard.mayBeLater': 'Kanske senare',
  'onboard.aboutCourse': 'Berätta för oss om din kurs',
  'onboard.close': 'Stäng',
  'course.addTitle': 'Lägg till kurs',
  'common.PURCHASE': 'Köp',
  'common.CLOSE': 'Stäng',
  'open': 'öppna',
  'continue': 'Fortsätt',
  'yes': 'Ja',
  'no': 'Nej',
  'audio': 'Ljud',
  'courses.toc.PUBLISH_SUCCESS': 'Lyckades!',
  'courses.toc.PUBLISH_MESSAGE': 'Studenterna kommer att se dina ändringar nästa gång de öppnar innehållet.',
  'errors.GENERIC_TITLE': 'Du har inte åtkomst just nu',
  'errors.GENERIC_DESC': 'Börja med att uppdatera eller rensa dina cache. Om det inte fungerar ska du kontakta Pearson- ',
  'errors.GENERIC_LINK': 'support.',
  'errors.GENERIC_CODE': 'Felkod: {code}',
  'errors.SUBSCRIPTION_GENERIC_TITLE': 'Prenumeration hittades inte',
  'errors.SUBSCRIPTION_GENERIC_DESC': 'Ditt konto inkluderar inte tillgång till denna titel. Om du tror att du har fått detta meddelande av misstag kontaktar du Pearson teknisk support',
  'errors.SUBSCRIPTION_REGISTRATION_TITLE': 'Prenumeration hittades inte',
  'errors.SUBSCRIPTION_REGISTRATION_DESC': 'Din prenumeration inkluderar inte tillgång till e-textboken, men du kan prenumerera på den direkt med ett kreditkort.',
  'link.ACCESSIBILITY': 'https://www.pearson.com/us/higher-education/products-services-teaching/course-content/textbooks-and-etexts/pearson-etext/accessibility.html',
  'link.PRIVACY': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonPrivacyPolicy.html',
  'link.SUPPORT': 'https://support.pearson.com/getsupport/s/',
  'link.TOSURL': 'https://pi.pearsoned.com/v1/piapi/login/static/html/PearsonEULA.html',
  'link.FAQS_NONMOJO': '',
  'link.TERMS_OF_USE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/terms-of-use.html',
  'link.PRIVACY_NOTICE_NONMOJO': 'https://www.pearson.com/en-us/legal-information/privacy-policy.html',
  'link.ACCESSIBILITY_SUPPORT_NONMOJO': '',
  'menu.myAccount': 'Mitt konto',
  'menu.helpCenter': 'Hjälpcenter',
  'menu.preferencesCenter': 'Preferenscenter',
  'menu.CONTACT_SUPPORT': 'Kontakta Support',
  'menu.HELP_SUPPORT': 'Hjälp & support',
  'menu.FAQS': 'FAQ',
  'menu.CHAT_WITH_SUPPORT': 'Chatta med support',
  'menu.OTP_CODES': 'OTP-koder',
  'menu.LAUNCH_CODE': 'Starta kodlogg',
  'menu.SEND_CODE': 'Skicka ny kod till användare via e-post',
  'menu.SEND_CODE_PHONE': 'Skicka ny kod till användare via textmeddelande',
  'menu.LEGAL': 'Juridiskt',
  'menu.PRIVACY_NOTICE': 'Sekretessmeddelande',
  'menu.TITLE_INFO': 'Titelinformation',
  'menu.PEARSON_ACCESSIBILITY': 'Pearson-tillgänglighet',
  'menu.DEVICE_WARNING_MESSAGE': 'Registrera {deviceLimit} enheter. Byt ut 1 per månad.',
  'menu.ACCESSIBILITY': 'Tillgänglighet',
  'menu.ACCESSIBILITY_SUPPORT': 'Tillgänglighetssupport',
  'menu.DEVICES': 'Senaste enheter',
  'menu.THIS_DEVICE': 'Denna enhet',
  'menu.GET_THE_APP_DOWNLOAD': 'Ladda ner mobilappen',
  'menu.MOJO_APP_INFO': 'Gå till appbutiken på din telefon eller surfplatta för att använda Pearson+ offline.',
  'menu.DEVICE_LABEL': 'Enhet',
  'menu.DEVICE_DISCONNECT': 'Frånkoppla',
  'menu.FOXIT': 'Drivs av FoxIT',
  'menu.TERMS_OF_USE': 'Användarvillkor',
  'menu.SIGN_OUT': 'Logga ut',
  'menu.PRINT_PAGE': 'Skriv ut sida',
  'menu.COPY_RIGHT': 'Copyright © {year} Pearson Education Inc. All Rights Reserved.',
  'print.FOOTER_MESSAGE': 'Tryckt av {fullName}({email}) den {currentDate}.',
  'print.WATERMARK': 'Copyright © {year} Pearson Education',
  'device.SWAPPED_ALREADY': 'Du har redan bytt denna månad',
  'device.SWITCH_DEVICE': 'Byt till nuvarande enhet?',
  'device.SWITCH_ONCE': 'Eftersom du bara kan byta en gång i månaden kan du inte ångra detta.',
  'device.SEAT_TAKEN': 'Denna plats är upptagen',
  'device.DISCONNECT_DEVICE': 'Du kan endast logga in på 3 enheter. För att fortsätta här frånkopplar du en annan enhet.',
  'device.ALERT_TEXT': 'Kom ihåg att du bara kan byta enhet en gång per månad.',
  'device.DISCONNECT': 'Frånkoppla',
  'device.CONTINUE': 'Fortsätt',
  'device.HEADER': 'Avsluta din andra webbläsarsession?',
  'device.CLOSE': 'Tillbaka till startsidan',
  'device.CODE': 'Fortsätt här genom att ange den autentiseringskod som vi har skickat till {maskedEmail}. Fungerar den inte? Kontrollera din mapp med skräppost, {email}, eller kontakta {support}.',
  'device.TIMER': 'Du har {time} på dig att ange din kod här',
  'device.RESEND': '{resend}',
  'device.FAQ': 'FAQ',
  'device.RESEND_NAME': 'Skicka igen',
  'device.NOTE': 'Om du regelbundet använder Pearson+ på 2 platser, såsom på jobbet och hemma, ska du se till att logga ut när du är klar. Du kan använda Pearson+-mobilappen på upp till 2 enheter. Mer information finns i vår {faq}.',
  'device.NOTE_HEADER': 'Undvik detta nästa gång',
  'device.CONTACT_SUPPORT': 'kundsupport',
  'device.CONTACT_EMAIL': 'uppdatera din e-postadress',
  'device.INCORRECT': 'Fel – dubbelkontrollera din kod eller skicka den igen.',
  'device.MANY_ATTEMPTS': 'För många försök, försök skicka koden igen',
  'device.EXPIRED': 'Din tid har gått ut, försök skicka koden igen',
  'device.ACCESS_HEADER': 'Du är inne!',
  'device.ACCESS_DESC': 'Din session har autentiserats. Vill du uppdatera ditt lösenord när du ändå håller på?',
  'device.ACCESS_CHANGE_PASSWORD': 'Ändra lösenord',
  'device.ACCESS_RESET_PASSWORD': 'Återställ lösenord',
  'device.THREATONE_TITLE': 'Allt bra?',
  'device.THREATONE_DESC': 'Vi har upptäckt misstänkt aktivitet på ditt konto.',
  'device.THREATONE_DESC_TWO': 'Detta är en bra tidpunkt att byta ditt lösenord.',
  'device.MAY_BE_LATER': 'Kanske senare',
  'device.OKAY': 'Okej',
  'device.ACCOUNT_LOCK_DESC': 'För att hålla det säkert kommer vi att logga ut dig. Vi har skickat en länk för återställning av lösenord till den e-postadress som är kopplad till ditt konto.',
  'device.ACCOUNT_LOCK_TITLE': 'Vi märkte av lite skum aktivitet på ditt konto',
  'device.ACCOUNT_LOCK_TIMER': 'Du kommer att loggas ut om {time}',
  'navigation.PAGE': 'Sida',
  'launchcode.CREATEBY': 'Skapad av:',
  'launchcode.sentvia': 'Skickad via:',
  'launchcode.CODEINLAST': 'Koder under de senaste 7 dagarna:',
  'launchcode.TIMESENT': 'Tid skickad: ',
  'launchcode.ACCOUNTEMAIL': 'E-postadress för konto:',
  'launchcode.LAUNCHDIALOGTITLE': 'OTP-kodlogg',
  'textmessage.TITLE': 'Ange telefonnummer',
  'textmessage.PHONE_NUMBER': 'Telefonnummer',
  'textmessage.SEND_CODE': 'Skicka kod',
  'textmessage.INVALID_NUMBER': 'Ogiltigt telefonnummer.',
  'textmessage.SUCCESS_MESSAGE': 'Kod skickad',
  'remove.title': 'Ta bort titel?',
  'remove.subTitle': 'Du kan alltid gå tillbaka den senare – använd bara sökningen för att lägga till den igen.',
  'remove.buttonText': 'Ta bort',
  'search.searchPlaceHolderPPlus': 'Sök efter ISBN, titel eller författare',
  'search.searchPlaceHolderEText': 'Sök dit bibliotek',
  'footer.downloadMobileApp': 'Ladda ner mobilappen',
  'footer.termsOfUse': 'Användarvillkor',
  'footer.privacy': 'Sekretess',
  'footer.cookies': 'Cookies',
  'footer.doNotSellMyPersonalInformation': 'Sälj inte min personliga information',
  'footer.accessibility': 'Tillgänglighet',
  'footer.patentNotice': 'Patentmeddelande',
  'footer.copyrights': 'Pearson Alla rättigheter förbehållna.',
  'hero.toc.defaultPlacehoder': '--- välj ett ämne ---',
  'hero.openEtextBookV1': 'Öppna e-lärobok',
  'hero.heroHeading': 'Eftersom du studerar <span>{channel_title}</span>',
  'hero.heroHeadingForBundleUser': 'Studieförberedelse',
  'hero.study.help': 'Få studiehjälp',
  'hero.study.jumpBackIn': 'Dags att återgå',
  'hero.study.numOfUsers': 'För tillfället är det <b>{num_of_users}</b> studenter som använder Kanaler.',
  'hero.heroChannel.cardsHeading': 'Fortsätt från där du slutade',
  'hero.marketingcard1.copy.title': 'Lär dig med videor',
  'hero.marketingcard1.copy.description': 'Titta på korta videor som förklarar svåra ämnen.',
  'hero.marketingcard2.copy.title': 'Övningsuppgifter',
  'hero.marketingcard2.copy.description': 'Förbered dig på examen med tusentals examensliknande frågor och videolösningar.',
  'hero.marketingcard3.copy.title': 'Få erfaren hjälp',
  'hero.marketingcard3.copy.description': 'Publicera frågor och får svar från ämnesexperter.',
  'hero.popularTopics.heading': 'Andra populära ämnen i denna Kanal',
  'hero.popularChannels.headingv1': 'Ta en annan kurs?',
  'hero.popularChannels.descriptionv2': 'Bläddra i populära studiehjälpsämnen.',
  'hero.practice': 'Öva',
  'hero.herobook.mappedChannelHeading': 'Rekommenderad studiehjälp i denna kanal',
  'libraryL2.myBooks': 'Mina böcker',
  'libraryL2.archived': 'Arkiverade',
  'libraryL2.back': 'Tillbaka',
  'hero.practiceProblem': 'Övningsuppgift',
  'nativeAppBanner.drawer.title': 'Öppna i ...',
  'nativeAppBanner.drawer.pearsonApp': 'Pearson+-appen',
  'nativeAppBanner.banner.title': 'Pearson+-appen',
  'nativeAppBanner.banner.description': 'Lär dig när du är på språng',
  'hero.promotionalcard.list1': 'Korta videor som förklarar svåra ämnen',
  'hero.promotionalcard.list2': 'Tusentals examensliknande frågor',
  'hero.promotionalcard.list3': 'Få svar från ämnesexperter',
  'hero.studyandexamprep': 'Studieförberedelse',
  'hero.heroBook.sectionSubHeadingV1': 'Dela in tuffa ämnen med videoförklaringar och övningsfrågor skräddarsydda efter din kurs.',
  'hero.heroBook.sectionSubHeadingV2': 'Dela in tuffa ämnen med begreppsförklaringar och övningsfrågor skräddarsydda efter din kurs.',
  'hero.SeeAllStudyOptions': 'Se alla studiealternativ',
  'hero.herobook.mappedChannelHeadingV1': 'Rekommenderade videor och övningsfrågor',
  'hero.popularTopics.headingV1': 'Andra populära ämnen',
  'hero.heroHeadingV1': 'För <span>{replace_value}</span>',
  'hero.learnmore': 'Läs mer',
  'hero.eTextbook': 'e-lärobok',
  'hero.goToPage.label': 'Gå till sidan',
  'subscription.studyTitle': 'Studieförberedelse',
  'print.printAvailTitle': 'Vill du skriva ut denna sida? Så här gör man',
  'print.printAvailDesc': 'I din eTexbook väljer du kontoikonen högst upp i höger hörn. Från alternativen väljer du "Skriv ut sida" och väljer sedan dina utskriftsinställningar.',
  'print.printNotAvailTitle': 'Utskriftsalternativet för denna e-text är inte aktiverat.',
  'print.printNotAvailDesc': 'För smidig tillgång offline kan du ladda ner din titel via Pearson+-mobilappen och njuta av flexibiliteten att kunna studera när som helst och var som helst!',
  'hero.header.cta': 'Gå till studieverktyg',
  'hero.header.ctav2': 'Öppna studieförberedelse',
  'hero.marketing.title': 'Hitta din e-lärobok',
  'hero.marketing.subTitle': 'Välj från över 2 000 e-läroböcker med ljudfiler, flashkort, anteckningar och mycket mer. Endast $10,99/må för en 4-månadersperiod.',
  'hero.popularchannels.desc': 'Få studiehjälp med dessa bästa ämnen',
  'hero.removecourse.title': 'Ta bort kursen från instrumentpanel?',
  'hero.removecourse.description': 'Du kan alltid lägga till denna kurs igen på din instrumentpanel genom att klicka på "Lägg till kurs"',
  'hero.removecourse.primaryCtaText': 'Ta bort',
  'hero.removecourse.secondaryCtaText': 'Avbryt',
  'hero.tableOfContents': 'Innehållsförteckning',
  'hero.search': 'Sök',
  'hero.emptystate.cta': 'Sök e-läroböcker',
  'hero.watch_it_again': 'Titta på den igen',
  'hero.mondly.learnLang.title': 'Lär dig ett nytt språk helt gratis',
  'hero.mondly.subTitle': 'Pearson e-lärobok-användare får tre månader av Mondly från Pearson.',
  'hero.mondly.description': 'De flesta appar för språkinlärning låter dig bara lära dig från engelska. Men det är bäst att lära sig från sitt modersmål, så Mondly låter dig lära dig från något av våra <strong>41 olika språk</strong>.',
  'hero.mondly.startLearningCTA': 'Börja lära dig',
  'hero.mondly.marketing.bestApp': 'Bästa appen',
  'hero.mondly.marketing.appStore': 'App Store',
  'hero.mondly.marketing.appYear': 'Årets app',
  'hero.mondly.marketing.fbStart': 'Vinnare av Facebook FbStart – 2017 EMEA',
  'hero.mondly.marketing.editorChoice': 'Redaktionens val',
  'hero.mondly.marketing.googlePlay': 'Google Play',
  'header.menu.learnLanguage': 'Lär dig ett språk',
  'header.menu.moreAtPearson': 'Mer hos Pearson',
  'hero.subscriptionStatusTitle2': 'Dina Pearson+-resurser',
  'hero.startStudying': 'Börja studera',
  'onboard.studyMaterials': 'Välj ditt ämne och vi kommer att skapa en instrumentpanel med anpassade studiematerial.',
  'hero.myETextbooks': 'Mina e-läroböcker',
  'header.continueInTheApp': 'Fortsätt i appen',
  'hero.learnTxt': 'Lär dig',
  'hero.examPrepTxt': 'Examensförberedelse',
  'hero.aITutorTxt': 'AI-lärare',
  'AI.toolTip': 'Fråga mig något i din e-lärobok',
  'hero.studyExamPrepAllYourCourses': 'Studieförberedelse för alla dina kurser',
  'header.qrCode.subHeaderTxt': 'Använd denna QR-kod för att snabbt och säkert logga in på Pearson+-appen på din mobila enhet.',
  'header.qrCode.dontHaveApp': 'Har du inte appen?',
  'header.qrCode.footerTxt': 'Om du skannar denna kod kommer du att omdirigeras till App Store eller Google Play. När appen är nedladdad loggar du in genom att skanna den igen.',
  'header.qrCode.errorMsg': 'QR-koden laddades inte. Stäng och försök igen.',
  'hero.yourETextbook': 'Din e-lärobok',
  'onboard.addCourseWithEtextBundle': 'Lägg till kurs med hjälp av Studieförberedelse',
  'onboard.disableTooltipText': 'Alla studieförberedelsekurser tillagda!',
  'subscriptionstatus.bundlecta': 'Åtkomst till studieförberedelse',
  'subscriptionstatus.nonbundlecta': 'Åtkomst till studieförberedelse',
  'channel.genericBundle': 'Använd din studieförberedelse som hjälp i dina andra kurser',
  'channel.relatedBundle': 'Använd även din studieförberedelsekurs som hjälp i dina andra kurser',
  'onboard.courseAdded': 'Kurs tillagd!',
  'hero.flashcards': 'Flashkort',
  'relatedChannelCard.title': 'Förbättra din inlärning med denna relaterade resurs',
  'relatedChannelCard.badgeText': 'Relaterad studieförberedelse',
  'sessionInactivity.title': 'Är du fortfarande kvar?',
  'sessionInactivity.description': 'Din session kommer att ta timeout om <b>%TIMER%</b> på grund av inaktivitet.<br/>Vill du förbli inloggad?',
  'sessionInactivity.keepMeSignIn': 'Håll mig inloggad',
  'sessionInactivity.signOut': 'Logga ut',
  'sessionTimeout.title': 'Session tog timeout',
  'sessionTimeout.description': 'Din session har tagit timeout på grund av inaktivitet.',
  'print.qrCode.header': 'Använd denna QR-kod för att öppna Pearson+-appen på din mobila enhet.',
  'print.qrCode.footer': 'Om du skannar denna kod kommer du att omdirigeras till App Store eller Google Play. När appen är installerad loggar du in för att ladda ner och få åtkomst till din titel.',
  'hero.nestest.title': 'Förbered dig för ditt lärarprov',
  'hero.nestest.subTitle': 'Användare av Pearson+ har nu tillgång till förberedelsekurser och övningstester som följer de nationella riktlinjerna, för att förbereda sig inför lärarproven.',
  'hero.channelAI.title': 'Behöver du hjälp? AI-lärare har din rygg.',
  'hero.channelAI.desc': 'Ställ en fråga och få stegvis hjälp med läxorna, studierekommendationer och mycket mer – personlig hjälp när du behöver det.',
  'hero.channelAI.action': 'Ställ fråga till AI-lärare nu',
  'new': 'Nytt!',
  'hero.practice.numOfUsers': 'Detta avsnitt har <b>{practice_num_of_users}</b> övningsuppgifter.',
  'hero.practice.cta': 'Öva nu',
  'hero.practice.title': 'Övningsuppgift',
  'diagnostics.errorMsg': 'Diagnostik laddades inte. Stäng och försök igen',
  'qrcode.title': 'Börja studera var som helst',
  'qrcode.subtitle': 'Lär dig var som helst och när som helst med Pearson+-mobilappen. Ladda ner nu och få tillgång till en smidig inlärningsupplevelse.',
  'qrcode.detailsv1': 'Med Pearson+-appen kan du använda denna QR-kod för att fortsätta där du slutade. Sök i din bok, studera med flashkort, titta på videolektioner och mycket mer, oavsett var du befinner dig.',
  'qrcode.detailsv2': 'Skanna denna QR-kod när du vill logga in snabbt och fortsätt precis där du slutade.',
  'qrcode.details': 'Med Pearson+-appen kan du använda denna QR-kod för att fortsätta där du slutade.',
  'qrcode.appstore': 'App Store',
  'qrcode.playstore': 'Google Play',
  'nativePromoBanner.description': 'Lär dig var som helst och när som helst med Pearson+-mobilappen. Ladda ner nu och få tillgång till en smidig inlärningsupplevelse.',
  'install': 'Install',
  'header.menu.createCourse': 'Ny kurs',
  'header.dropdown.courses': 'Kurser',
  'header.dropdown.recentlyViewed': 'Senaste visade',
  'header.dropdown.viewAll': 'Visa alla kurser',
  'aet.courseHeader.inviteStudents': 'Bjud in studenter',
  'aet.courseHeader.inviteStudentModal.subTitle': 'Bjud in studenter till att få tillgång till denna e-textbok genom att kopiera länkadressen eller instruktionerna nedan i ditt e-postmeddelande eller din kursplan.',
  'aet.courseHeader.inviteStudentModal.linkAddress': 'Länkadress',
  'aet.courseHeader.inviteStudentModal.copyLink': 'Kopiera länk',
  'aet.courseHeader.inviteStudentModal.instructionsTitle': 'Instruktioner med länkadress',
  'aet.courseHeader.inviteStudentModal.copyInstructions': 'Kopiera instruktioner',
  'aet.courseHeader.inviteStudentModal.instructionIntro': 'Det är dags att få tillgång till {bookTitle} e-textboken för {courseName}.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionAccessLink': 'När du är redo öppnar du e-textboken på: {enrollmentLink}\n\n',
  'aet.courseHeader.inviteStudentModal.instructionSignIn': 'Du kommer att ombes att logga in med ditt befintliga Pearson-konto. Om du inte ha ett Pearson-konto kommer du att få möjlighet till att skapa ett.\n\n',
  'aet.courseHeader.inviteStudentModal.instructionHelp': 'Behöver du hjälp?',
  'aet.courseHeader.inviteStudentModal.instructionHelpLink': 'AskPearson',
  'aet.courseHeader.startDate': 'Startdatum:',
  'aet.courseHeader.endDate': 'Slutdatum:',
  'aet.courseHeader.start': 'Start:',
  'aet.courseHeader.end': 'End:',
  'aet.courseHeader.moreOptions': 'More options',
  'aet.courseHeader.entitlement': 'Entitlement:',
  'aet.courseHeader.format': 'Format:',
  'aet.home.manageroster': 'Hantera förteckning',
  'aet.home.managegradesync': 'Hantera betygsynkronisering',
  'aet.home.copycourse': 'Kopiera kurs',
  'aet.home.unlinkcourse': 'Unlink course',
  'aet.tempAccess.warningBannerMessage': 'Temporary access expires on {date}',
  'aet.tempAccess.upgradeAccessLabel': 'Upgrade access',
  'aet.tempAccess.expiredTitle': 'Temporary access has expired',
  'aet.tempAccess.expiredWithActionDescription': 'Your progress has been saved. Upgrade your access now to continue where you left off.',

  'aet.instructorCourse.tabs.current': 'Nuvarande',
  'aet.instructorCourse.tabs.past': 'Tidigare',
  'aet.instructorCourse.tabs.courseSettings': 'Kursinställningar',
  'aet.instructorCourse.tabs.assignmentSettings': 'Assignment settings',
  'aet.instructorCourse.assignmentSettings.lmsAlertMessage': 'Important: Your LMS may also have assignment scoring settings. Changes in both places are applied together. To avoid unintended changes to final scoring, update settings in one place.',
  'aet.instructorCourse.assignmentSettings.gradebookSectionTitle': 'Display assignment scores in gradebook as',
  'aet.instructorCourse.assignmentSettings.gradebookInfoButtonAriaLabel': 'Learn about raw score and equal weighting',
  'aet.instructorCourse.assignmentSettings.rawScoreTitle': 'Raw score',
  'aet.instructorCourse.assignmentSettings.rawScoreDescription': 'Assignment scores vary based on the number of questions in each assignment.',
  'aet.instructorCourse.assignmentSettings.equalWeightingTitle': 'Equal weighting',
  'aet.instructorCourse.assignmentSettings.equalWeightingDescription': 'All assignments have the same base value.',
  'aet.instructorCourse.assignmentSettings.baseValueLabel': 'Base value:',
  'aet.instructorCourse.assignmentSettings.availabilitySectionTitle': 'Assignment availability',
  'aet.instructorCourse.assignmentSettings.availabilityFieldLabel': 'Assignments are available to students',
  'aet.instructorCourse.assignmentSettings.dueDatesSectionTitle': 'Scheduling defaults',
  'aet.instructorCourse.assignmentSettings.defaultDueTimeLabel': 'Default due time',
  'aet.instructorCourse.assignmentSettings.courseTimeZoneLabel': 'Course time zone',
  'aet.instructorCourse.assignmentSettings.cancelButtonLabel': 'Cancel',
  'aet.instructorCourse.assignmentSettings.saveButtonLabel': 'Save changes',
  'aet.instructorCourse.assignmentSettings.gradebookInfoModalTitle': 'Raw Score vs Equal Weighting',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreHeading': 'Raw Score:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoRawScoreBody': 'Grades reflect total points earned out of total points possible across all assignments. Longer or higher-point assignments naturally impact the final grade more.',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingHeading': 'Equal Weighting:',
  'aet.instructorCourse.assignmentSettings.gradebookInfoEqualWeightingBody': 'Every assignment is normalized using a consistent base value so that each task contributes equally to the final grade, regardless of length or point total.',
  'aet.instructorCourse.assignmentSettings.baseValueRequired': 'Base value is required',
  'aet.instructorCourse.assignmentSettings.baseValueInvalid': 'Enter a value between 1 and 100',
  'aet.instructorCourse.assignmentSettings.availability.immediate': 'Immediately upon publish',
  'aet.instructorCourse.assignmentSettings.availability.fourWeeksBefore': '4 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.twoWeeksBefore': '2 weeks before due date',
  'aet.instructorCourse.assignmentSettings.availability.oneWeekBefore': '1 week before due date',
  'aet.instructorCourse.tabs.manageRoster': 'Hantera förteckning',
  'aet.instructorCourse.currentCourses.title': 'Nuvarande kurser',
  'aet.instructorCourse.pastCourses.title': 'Tidigare kurser',
  'aet.instructorCourse.archivedCourses.title': 'Archived courses',
  'aet.instructorCourse.archivedCourses.description': 'Archived titles are hidden from Current and Past. Your access to each title doesn’t change — unarchive it any time to put it back on your bookshelf.',
  'aet.instructorCourse.archivedCourses.emptyStateTitle': 'No archived titles',
  'aet.instructorCourse.archivedCourses.emptyStateDescription': 'Archive a title from Current or Past using its ··· menu. It moves here without changing your access.',
  'aet.instructorCourse.archiveDialog.title': 'Archive title(s)',
  'aet.instructorCourse.archiveDialog.description': 'Archived titles will move to the Archived tab, and all courses that use that title will be archived. They can still be accessed from the archived section, directly from the MLM course, and from Console. You can unarchive it anytime from the Archived tab.',
  'aet.instructorCourse.archiveDialog.confirmCTA': 'Archive',
  'aet.instructorCourse.unarchiveDialog.title': 'Unarchive title(s)',
  'aet.instructorCourse.unarchiveDialog.description': 'Unarchived titles will be accessible from your home page.',
  'aet.instructorCourse.unarchiveDialog.confirmCTA': 'Unarchive',
  'aet.home.archiveCourse': 'Archive',
  'aet.home.unarchiveCourse': 'Unarchive',
  'aet.instructorCourse.createOrCopy.title': 'Skapa eller kopiera en kurs i Pearson e-textbok',
  'aet.instructorCourse.createOrCopy.sectionTitle': 'Kopiera en annan lärares kurs eller skapa en ny',
  'aet.instructorCourse.createOrCopy.copyPanel.title': 'Kopiera en annan lärares kurs',
  'aet.instructorCourse.createOrCopy.copyPanel.subtitle': 'Ange kurs-ID:t för att hitta kursen som du vill kopiera.',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdLabel': 'Kurs-ID',
  'aet.instructorCourse.createOrCopy.copyPanel.courseIdPlaceholder': 'Ange kurs-ID',
  'aet.instructorCourse.createOrCopy.copyPanel.searchedForPrefix': 'Du sökte efter',
  'aet.instructorCourse.createOrCopy.catalogPanel.title': 'Skapa ny kurs från katalogen',
  'aet.instructorCourse.createOrCopy.catalogPanel.subtitle': 'Sök efter titel, författare, ISBN eller ämnesnyckelord.',
  'aet.instructorCourse.createOrCopy.catalogPanel.searchPlaceholder': 'Sök...',
  'aet.instructorCourse.createOrCopy.showMoreLabel': 'Visa mer',
  'aet.instructorCourse.createOrCopy.showLessLabel': 'Visa mindre',
  'aet.instructorCourse.cancel': 'Avbryt',
  'aet.instructorCourse.loading': 'Laddar ...',
  'aet.instructorCourse.courseForm.copyError': 'Your course cannot be copied because the title is no longer supported. Please contact your Pearson representative or customer support.',
  'aet.instructorCourse.courseForm.gradeSync': 'Betygsynkronisering',
  'aet.instructorCourse.courseForm.gradeSyncLinkLabel': 'Hantera betygsynkronisering',
  'aet.instructorCourse.courseForm.courseNameLabel': 'Kursnamn',
  'aet.instructorCourse.courseForm.courseNamePlaceholder': 'Utan titel',
  'aet.instructorCourse.courseForm.sectionNameLabel': 'Avsnittsnamn',
  'aet.instructorCourse.courseForm.sectionNamePlaceholder': 'Utan titel',
  'aet.instructorCourse.courseForm.institutionFieldLabel': 'Institution',
  'aet.instructorCourse.courseForm.institutionSelectLabel': 'Select an Institution',
  'aet.instructorCourse.courseForm.institutionPlaceholder': 'Start typing your institution',
  'aet.instructorCourse.courseForm.institutionRequiredError': 'Institution är obligatoriskt',
  'aet.instructorCourse.courseForm.institutionSearchError': 'Något gick fel. Försök igen.',
  'aet.instructorCourse.courseForm.institutionNoResults': 'Inga resultat hittades',
  'aet.instructorCourse.courseForm.findAnotherInstitutionLabel': 'Find another institution',
  'aet.instructorCourse.courseForm.higherEducationSectionLabel': 'Higher Education:',
  'aet.instructorCourse.courseForm.k12InstitutionsSectionLabel': 'K12 Institutions:',
  'aet.instructorCourse.courseForm.k12InstitutionsDescription': 'Go to your My Courses dashboard to create courses for this type of institution',
  'aet.instructorCourse.courseForm.createK12CourseLabel': 'Create K-12 course',
  'aet.instructorCourse.courseForm.startDateLabel': 'Kursens startdatum',
  'aet.instructorCourse.courseForm.endDateLabel': 'Kursens slutdatum',
  'aet.instructorCourse.courseForm.datePlaceholder': 'dd/mm/åå',
  'aet.instructorCourse.courseForm.allowCopyLabel': 'Tillåt andra att kopiera denna kurs',
  'aet.instructorCourse.courseForm.shareCodeLabel': 'Dela denna kod med lärarna som vill kopiera denna kurs',
  'aet.instructorCourse.courseForm.copyCodeLabel': 'Kopiera kod',
  'aet.instructorCourse.courseForm.optionalSuffix': '(valfritt)',
  'aet.instructorCourse.courseForm.formValidationLiveRegion': 'Formuläret har ett valideringsfel',
  'aet.instructorCourse.courseForm.submitContinue': 'Fortsätt',
  'aet.instructorCourse.courseForm.submitContinueLoading': 'Sparar...',
  'aet.instructorCourse.courseForm.submitError': 'Vi kunde inte skapa din kurs. Försök igen.',
  'aet.instructorCourse.courseForm.submitEditError': 'Vi kunde inte spara dina ändringar. Försök igen.',
  'aet.instructorCourse.courseForm.submitSaveChanges': 'Spara ändringar',
  'aet.instructorCourse.courseForm.materialsHeader': 'Kursmedel',
  'aet.instructorCourse.courseForm.resolveError': 'Vi kunde inte ladda kursmedlen. Försök igen.',
  'aet.instructorCourse.courseForm.copySourceError': 'We could not load the course to copy. Please search again from Create or copy course.',
  'aet.instructorCourse.coursesSort.lastViewed': 'Senaste visade',
  'aet.instructorCourse.coursesSort.recentlyAdded': 'Senaste tillagda',
  'aet.instructorCourse.coursesSort.aToZ': 'A till Z',
  'aet.instructorCourse.coursesSort.zToA': 'Z till A',
  'aet.instructorCourse.manageRoster.column.name': 'Namn',
  'aet.instructorCourse.manageRoster.column.role': 'Roll',
  'aet.instructorCourse.manageRoster.column.email': 'E-post',
  'aet.instructorCourse.manageRoster.column.access': 'eTextbook Access',
  'aet.instructorCourse.manageRoster.column.status': 'Status',
  'aet.instructorCourse.manageRoster.column.statusInfoTooltip': 'Status information',
  'aet.instructorCourse.manageRoster.statusInfoModal.title': 'Status',
  'aet.instructorCourse.manageRoster.statusInfoModal.bodyParagraph1': 'This status reflects Pearson enrollment and may not match a student\'s enrollment status in your linked LMS course.',
  'aet.instructorCourse.manageRoster.statusInfoModal.bodyParagraph2': 'Students marked as Inactive will not have grades synced back to the LMS.',
  'aet.instructorCourse.manageRoster.access.tempAccessTitle': 'Temporary access',
  'aet.instructorCourse.manageRoster.access.active': 'Active eTextbook access',
  'aet.instructorCourse.manageRoster.access.endsOn': 'Ends: {date}',
  'aet.instructorCourse.manageRoster.access.ended': 'Ended:',
  'aet.instructorCourse.manageRoster.changeTo': 'Change to:',
  'aet.instructorCourse.manageRoster.notAvailable': '---',
  'aet.instructorCourse.roster.role.student': 'Student',
  'aet.instructorCourse.roster.role.ta': 'Lärarassistent',
  'aet.instructorCourse.roster.role.instructor': 'Lärare',
  'aet.instructorCourse.roster.status.active': 'Aktiv',
  'aet.instructorCourse.roster.status.inactive': 'Inaktiv',
  'aet.instructorCourse.manageRoster.filter.allMembers': 'Alla medlemmar',
  'aet.instructorCourse.manageRoster.filter.activeStudents': 'Aktiva studenter',
  'aet.instructorCourse.manageRoster.filter.inactiveStudents': 'Inaktiva studenter',
  'aet.instructorCourse.manageRoster.filter.teachingAssistant': 'Lärarassistent',
  'aet.instructorCourse.manageRoster.filter.instructor': 'Lärare',
  'aet.instructorCourse.courseForm.materialsAuthorLabel': 'Författare:',
  'aet.instructorCourse.courseForm.materialsIsbnLabel': 'ISBN:',
  'aet.instructorCourse.courseForm.materialsCreationDateLabel': 'Kursens skapandedatum:',
  'aet.instructorCourse.noCoursesFound': 'Inga kurser hittades',
  'aet.instructorCourse.searchNoResultsTitle': 'No courses match “{searchTerm}”',
  'aet.instructorCourse.searchNoResultsDescription': 'Try a different course name.',
  'aet.instructorCourse.clearSearch': 'Clear search',
  'aet.instructorCourse.noCoursesEmptyStateTitle': 'Nothing here yet',
  'aet.instructorCourse.noCoursesEmptyStateDescription': 'Courses you create or are added to will appear here.',
  'aet.instructorCourse.backButton': 'Tillbaka',
  'aet.instructorCourse.selectCourse': 'Välj kurs',
  'aet.home.linkedToLms': 'Länka till LMS',
  'aet.instructorCourse.courseForm.title.create': 'Skapa kurs',
  'aet.instructorCourse.courseForm.title.copy': 'Kopiera kurs',
  'aet.instructorCourse.courseForm.title.edit': 'Kursinformation',
  'aet.instructorCourse.courseForm.copiedContentAccordion.settings.title': 'Inställningar',
  'aet.studentRoster.manageStudentRosterButton': 'Hantera studentförteckning',
  'aet.studentRoster.dontHaveAnyStudent': 'Looks like you don’t have any students.',
  'aet.studentRoster.lmsEmptyState.title': 'No students have accessed the course yet',
  'aet.studentRoster.lmsEmptyState.description': 'As soon as students click through from your LMS, you’ll see their names and progress here.',
  'aet.studentRoster.nonlmsEmptyState.description': 'As soon as students join your course, you’ll see their names and progress here.',
  'aet.syllabus.editContentDisabledTooltip': 'Cannot update assignment while student work is in progress.',
  'aet.assignments.exportStudentProgressButton': 'Exportera studentframsteg',
  'aet.home.student.roaster.enrolmentInformationTitle': 'Enrolment information',
  'aet.home.student.roaster.enrolmentInformation.status': 'Status:',
  'aet.home.student.roaster.enrolmentInformation.enrolled': 'Registrerade:',
  'aet.home.student.roaster.enrolmentInformation.access': 'Access:',
  'aet.home.student.roaster.enrolmentInformation.role': 'Roll:',
  'aet.home.student.roaster.enrolmentInformation.promotionCardTitle': 'Befordra {studentName} ?',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent1': 'I sin roll som lärarassistent kommer denna person att kunna följa alla studenters framsteg och prestationer i denna klass.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardContent2': 'De kommer också att kunna hantera studenter och uppgifter, men de kommer dock inte att kunna radera klassen.',
  'aet.home.student.roaster.enrolmentInformation.promotionCardConfirmLabel': 'Befordra till lärarassistent',
  'aet.home.manageRoster.searchPlaceholder': 'Sök efter student',
  'aet.home.manageRoster.inactivateButtonLabel': 'Inaktivera valda studenter',
  'aet.home.manageRoster.FilterLabel': 'Visa',
  'aet.home.manageRoster.updatingMessage': 'Uppdaterar förteckning... Detta kan ta några minuter.',
  'aet.home.courses.search.searchPlaceHolder': 'Sök dina kurser',
  'aet.courses.emptyStateDescription': 'Börja skapa din kurs genom att välja ett alternativ nedan.',
  'nativePromoBanner.continueInBrowser': 'Fortsätt i webbläsare',
  'globalnav.tooltip.hideNavText': 'Dölj navigering',
  'globalnav.tooltip.showNavText': 'Visa navigering',
  'aet.syllabus.progressTitle': 'Extraherar ...',
  'aet.syllabus.progressDesc': 'Vänta ett ögonblick medan vi behandlar din kursplan.',
  'aet.syllabus.uploadInputLabel': 'Dra och släpp filer här, eller klicka för att ladda upp',
  'aet.syllabus.uploadSyllabusTabLabel': 'Ladda upp kursplan',
  'aet.syllabus.dateAdjusterTabLabel': 'Datumväljare',
  'aet.syllabus.addManuallyTabLabel': 'Lägg till uppgifter manuellt',
  'aet.syllabus.addEditLaterText': 'Du kan alltid lägga till och redigera uppgifter senare',
  'aet.syllabus.editAssignmentLabel': 'Redigera uppgift',
  'aet.syllabus.addAssignmentLabel': 'Lägg till uppgift',
  'aet.syllabus.assignmentTitleLabel': 'Uppgiftens namn',
  'aet.syllabus.assignmentTitleAutoPlaceholder': 'Automatically generated',
  'aet.syllabus.dueDateLabel': 'Deadline',
  'aet.syllabus.editDueDateLabel': 'Redigera inlämningsdatum',
  'aet.syllabus.chaptersCoveredLabel': 'Välj vilka kapitel eller avsnitt som ska ingå.',
  'aet.syllabus.updateCtaLabel': 'Uppdatera uppgift',
  'aet.syllabus.addCtaLabel': 'Lägg till uppgift',
  'aet.syllabus.uploadLabel': 'Ladda upp',
  'aet.syllabus.confirmLabel': 'Bekräfta',
  'aet.syllabus.addContentLabel': 'Lägg till innehåll',
  'aet.syllabus.addEditContentLabel': 'Lägg till/redigera innehåll',
  'aet.syllabus.notPublishedLabel': 'Inte publicerade',
  'aet.syllabus.updateDatesLabel': 'Uppdatera datum',
  'aet.syllabus.dateNormalization.yearAdjustedContentSingle': 'Ditt inlämningsdatum uppdaterades. Granska det och publicera sedan.',
  'aet.syllabus.coverageDedupe.adjustedContent': 'Din information om kapitel/avsnitt uppdaterades. Granska det och publicera sedan.',
  'aet.syllabus.unassignedCoverageStatus': 'Vissa kapitel är inte tilldelade ännu. Tilldela dem innan du publicerar.',
  'aet.syllabus.dateNormalization.manualEntryContent': 'Add a due date before you publish.',
  'aet.syllabus.pastDuePublishStatus': 'Update due date before you publish.',
  'aet.deleteAssignmentTitle': 'Radera uppgift?',
  'aet.deleteAssignmentTitleMultiple': 'Ta bort uppgifter?',
  'aet.deleteAssignmentWarning': 'Denna åtgärd kan inte återställas, och alla tillhörande inlämningar och studentuppgifter kommer att döljas.',
  'aet.deleteAssignmentKeepCTA': 'Behåll uppgift',
  'aet.deleteAssignmentDeleteCTA': 'Radera',
  'aet.assignments.loadingAsset': 'Laddar tillgång ...',
  'aet.assignments.addToDate': 'Lägg till inlämningsdatum',
  'aet.assignments.previewAsStudent': 'Förhandsgranska som student',
  'aet.assignments.questionsAndTopics': 'Frågor och ämnen',
  'aet.assignments.questionsAndTopicsModal.doneLabel': 'Klar',
  'aet.assignments.questionsAndTopicsModal.dueDateLabel': 'Deadline',
  'aet.assignments.questionsAndTopicsModal.questionsTotalLabel': 'Totalt antal frågor',
  'aet.assignments.questionsAndTopicsModal.questionOfTotalLabel': 'Fråga {count} av {total}',
  'aet.assignments.questionsAndTopicsModal.sectionSelectLabel': 'Select a section',
  'aet.assignments.publishToStudents': 'Publicera till studenter',
  'aet.assignments.availableToStudentsOn': 'Available to students on {0}',
  'aet.syllabus.addDateLabel': 'Lägg till datum',
  'aet.assistedSchedule.addToAssignmentModalTitle': 'Add to assignment',
  'aet.assistedSchedule.addToAssignmentModalEmptyLabel': 'No content yet',
  'aet.doneLabel': 'Klar',
  'aet.assignments.dueDateLabel': 'Uppgiftens inlämningsdatum',
  'aet.assignmentNameLabel': 'Assignment name',
  'aet.assignment.nameDisabledPlaceholder': 'Add content to generate a default name for your assignment',
  'aet.assignment.nameGeneratedPlaceholder': 'Automatically generated assignment name based on selected content',
  'aet.onboarding.getStarted.title': 'Get started creating assignments now:',
  'aet.onboarding.getStarted.manualSetup.title': 'Manuell inställning',
  'aet.onboarding.getStarted.manualSetup.description': 'Create and customize individual reading assignments and set their due dates',
  'aet.onboarding.getStarted.manualSetup.ctaLabel': 'Create manually',
  'aet.onboarding.getStarted.assistedScheduling.title': 'Weekly schedule',
  'aet.onboarding.getStarted.assistedScheduling.description': 'Pick a due day that repeats all term, then drag chapters into each week',
  'aet.onboarding.getStarted.assistedScheduling.ctaLabel': 'Build schedule',
  'aet.onboarding.getStarted.autoCreateAssignments.title': 'Auto-create assignments',
  'aet.onboarding.getStarted.autoCreateAssignments.description': 'Upload your syllabus to generate all reading assignments in seconds',
  'aet.onboarding.promotion.title': 'Turn assigned reading into active learning',
  'aet.onboarding.promotion.feature.1': 'Quickly create assignments with embedded questions, plus optional grade sync to your LMS',
  'aet.onboarding.promotion.feature.2': 'Använd insikter i realtid för att upptäcka kunskapsluckor, så att du kan agera god tid med tillförsikt',
  'aet.onboarding.promotion.feature.3': 'Studenterna får mer stöd genom målinriktad feedback och den inbyggda Pearson AI',
  'aet.onboarding.getStarted.previewQuestions.prompt': 'Want to see what’s available?',
  'aet.onboarding.getStarted.previewQuestions.link': 'Preview all questions',
  'aet.questionPreview.title': 'Preview questions',
  'aet.questionPreview.chapterSelectLabel': 'Select chapter',
  'aet.questionPreview.questionLabel': 'question',
  'aet.questionPreview.questionsLabel': 'questions',
  'aet.questionPreview.correctAnswer': 'Correct answer',
  'aet.questionPreview.noQuestions': 'No questions are available for this chapter.',
  'aet.assistedSchedule.pageTitle': 'Weekly schedule',
  'aet.assistedSchedule.reviewPageTitle': 'Create your assignments',
  'aet.assistedSchedule.sectionTitle': 'Set up a weekly schedule',
  'aet.assistedSchedule.sectionDescription': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysLabel': 'Have assignments due every',
  'aet.assistedSchedule.dueDaysTip': 'Tip: Make assignments due 1 or 2 days before your class meets in order to get the most out of assignment insights',
  'aet.assistedSchedule.dueDaysPlaceholder': 'Choose one or more days of the week',
  'aet.assistedSchedule.dueDaysRequiredError': 'Select at least one day',
  'aet.assistedSchedule.viewQuestions': 'View questions',
  'aet.assistedSchedule.dueTimeRequiredError': 'Due time is required',
  'aet.assistedSchedule.timeZoneRequiredError': 'Time zone is required',
  'aet.assistedSchedule.startDateLabel': 'Start assignments by',
  'aet.assistedSchedule.endDateLabel': 'End assignments by',
  'aet.assistedSchedule.datePlaceholder': 'mm/dd/yyyy',
  'aet.assistedSchedule.startDateRequiredError': 'Start date is required',
  'aet.assistedSchedule.endDateRequiredError': 'End date is required',
  'aet.assistedSchedule.scheduleInstruction': 'Drag content into the assignment slots to build your schedule.',
  'aet.assistedSchedule.dragZoneLabel': 'Drag content here to assign it to students',
  'aet.assistedSchedule.clickToEditLabel': 'Click to edit',
  'aet.assistedSchedule.clearDataLabel': 'Clear data',
  'aet.assistedSchedule.formValidationLiveRegion': 'Form has validation errors',
  'aet.assistedSchedule.noQuestionsError': 'Each assignment must include content with at least one question.',
  'aet.assistedSchedule.noQuestionsWarningLabel': 'Add content with at least 1 question to save this assignment.',
  'aet.assistedSchedule.autoNameAssignmentsLabel': 'Automatically name assignments based on content',
  'aet.assistedSchedule.autoNameAssignmentsInstruction': 'Assignment names will be generated from the content.',
  'aet.assistedSchedule.noAssignmentsModalTitle': 'No assignments can be created',
  'aet.assistedSchedule.noAssignmentsModalMessage': 'The selected date range is too short to generate any assignments. Extend the date range and try again.',
  'aet.assistedSchedule.addNewLabel': 'Add new',
  'aet.assistedSchedule.addToNewAssignmentLabel': 'Add to new assignment',
  'aet.assistedSchedule.saveAsDraftLabel': 'Save as draft',
  'aet.assistedSchedule.saveAndPublishLabel': 'Save and publish',
  'aet.assignments.allCaughtUpDescription': 'Inga uppgifter att lämna in den här veckan.',
  'aet.assignments.progressTitle': 'Förlopp',
  'aet.assignments.performanceTitle': 'Självförtroende',
  'aet.assignments.completionTitle': 'Slutförande',
  'aet.assignments.statusTitle': 'Status',
  'aet.assignments.addTooltip': 'Lägg till uppgift',
  'aet.assignments.deleteTooltip': 'Radera valda uppgifter',
  'aet.assignments.selectToDeleteLabel': 'Markera och ta bort',
  'aet.assignments.bulkEditTooltip': 'Redigera uppgifter i bulk',
  'aet.assignments.title': 'Uppdrag',
  'aet.assignments.assignmentTitle': 'Uppgift',
  'aet.assignments.dueDate': 'Deadline',
  'aet.tabular.searchPlaceholder.assignments': 'Sök uppgifter',
  'aet.tabular.searchPlaceholder.students': 'Sök studenter',
  'aet.tabular.searchPlaceholder.questions': 'Sök frågor',
  'aet.assignemnts.columnDueDateInfoTooltip': 'En eller flera studenter har fått förlängt inlämningsdatum för alla uppgifter',
  'aet.assignemnts.singleDueDateInfoTooltip': 'En eller flera studenter har fått förlängt inlämningsdatum för denna uppgift',
  'aet.assignemnts.masterDueDateInfoTooltip': 'En eller flera studenter har beviljats förlängt inlämningsdatum. Leta efter informationsikonen för att identifiera dessa uppgifter.',
  'aet.home.loading': 'Laddar ...',
  'aet.home.errorFetchingAssignments': 'Det gick inte att hämta uppgifterna',
  'aet.home.dueThisWeekTitle': 'Inlämningar denna vecka',
  'aet.home.allCaughtUpTitle': 'Inga fler uppgifter just nu!',
  'aet.home.allCaughtUpDescription': 'Inga uppgifter att lämna in den här veckan.',
  'aet.home.suggestedRemediationTitle': 'Föreslagen granskning av Studieförberedelse',
  'aet.home.noSuggestedRemediationTitle': 'Inget material föreslaget för granskning',
  'aet.home.noSuggestedRemediationDescription': 'Kom tillbaka efter din nästa uppgift.',
  'aet.home.assignmentIncludesTitle': 'Uppgiften inkluderar',
  'aet.home.sectionsLabel': 'Kapitel',
  'aet.home.questionsCount': '{count} frågor',
  'aet.home.dueLabel': 'Inlämningsdatum: {dueDate}',
  'aet.home.due': 'Förfaller:',
  'aet.home.progressCompletedLabel': 'Slutförd',
  'aet.home.progressCompletedPastDueLabel': 'Slutförda förfallna uppgifter',
  'aet.home.progressInProgressLabel': 'Pågår',
  'aet.home.progressPartiallyCompleteLabel': 'Partially complete',
  'aet.home.progressNotStartedLabel': 'Ej påbörjad',
  'aet.home.progressCountOfTotal': '{count} av {total}',
  'aet.home.NotAttemptedLabel': 'Inte påbörjad',
  'aet.home.questionsTotalLabel': 'Totalt antal frågor',
  'aet.home.progressCompletedOnTimeLabel': 'Slutförd i tid',
  'aet.home.segmentGreatLabel': 'Utmärkt',
  'aet.home.segmentGettingThereLabel': 'Okej',
  'aet.home.segmentNeedsReviewLabel': 'Behöver förbättras',
  'aet.home.segmentOkayLabel': 'Okej',
  'aet.home.editAssignmentTooltip': 'Redigera uppgift',
  'aet.home.deleteAssignmentTooltip': 'Radera uppgift',
  'aet.home.viewDetailsButton': 'Visa mer information',
  'aet.home.viewAsStudentButton': 'Visa som student',
  'aet.home.welcomeButtonText': 'Komma igång →',
  'aet.review.emptyStateTitle': 'Det finns inget att granska',
  'aet.review.emptyStateDescription': 'Kom tillbaka efter din nästa uppgift.',
  'aet.dashboard.tabs.upNext': 'Näst på tur',
  'aet.dashboard.tabs.welcome': 'Välkommen',
  'aet.dashboard.tabs.assignments': 'Uppdrag',
  'aet.dashboard.tabs.review': 'Granska',
  'aet.dashboard.tabs.studentRoster': 'Studenter',
  'aet.dashboard.classSchedule': 'Lektionsschema:',
  'aet.syllabus.dueTimeLabel': 'Inlämningsdatum',
  'hero.accessEducatorGuides': 'Få tillgång till lärarhandledningar',
  'aet.assignment.save': 'Spara',
  'aet.assignment.finish': 'Slutför',
  'aet.assignment.saveAndAdd': 'Spara och lägg till en till',
  'aet.assignment.delete': 'Radera',
  'aet.assignment.saveAndClose': 'Spara och stäng',
  'aet.studentRoster.title': 'Studenter',
  'aet.studentRoster.titlev1': 'Student',
  'aet.studentRoster.dueDatesAdjustmentLabel': 'Inlämningsdatum',
  'aet.studentRoster.dueDateAdjustment.option.0': 'Standard',
  'aet.studentRoster.dueDateAdjustment.option.2': '+2 dagar',
  'aet.studentRoster.dueDateAdjustment.option.3': '+3 dagar',
  'aet.studentRoster.dueDateAdjustment.option.5': '+5 dagar',
  'aet.studentRoster.dueDateAdjustment.option.week.1': '+1 vecka',
  'aet.studentRoster.dueDateAdjustment.option.week.2': '+2 veckor',
  'aet.studentRoster.dueDateAdjustment.option.lastDayOfClass': 'Sista skoldagen',
  'aet.studentRoster.dueDateAdjustment.toast.partial.title.multiple': '{count} of {total} assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.partial.message': '{skippedCount} assignments are past due. Edit manually to set new due dates.',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.title': 'No assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.allPastDue.message': 'All assignments are past due. Edit manually to set new due dates.',
  'aet.studentRoster.dueDateAdjustment.toast.success.title.multiple': '{count} assignments updated',
  'aet.studentRoster.dueDateAdjustment.toast.success.message.single': 'New due dates have been added to <b>{assignmentTitle}</b>.',
  'aet.studentRoster.dueDateAdjustment.toast.success.message.multiple': 'New due dates have been added to multiple assignments.',
  'aet.bulkEdit.bulkSplitInstruction': 'Vi ser till att dina uppgifter fördelas jämnt.',
  'aet.bulkEdit.Description': 'Figma ipsum component variant main layer. Editor library device auto star reesizing pencil horizontal. Polygon main list figjam star layout object connection hand scale.',
  'aet.bulkEdit.firstAssignmentDue': 'Första uppgiften ska lämnas in den',
  'aet.bulkEdit.lastAssignmentDue': 'Sista uppgiften ska lämnas in den',
  'aet.bulkEdit.assignmentsDueDays': 'Vilka dagar vill du att uppgifterna ska lämnas in?',
  'aet.bulkEdit.addEditLaterText': 'Vi använder AI för att skapa uppgifter. Du kan alltid lägga till och redigera uppgifter senare.',
  'aet.bulkEdit.monday': 'Måndag',
  'aet.bulkEdit.tuesday': 'Tisdag',
  'aet.bulkEdit.wednesday': 'Onsdag',
  'aet.bulkEdit.thursday': 'Torsdag',
  'aet.bulkEdit.friday': 'Fredag',
  'aet.bulkEdit.saturday': 'Lördag',
  'aet.bulkEdit.sunday': 'Söndag',
  'aet.toast.assignmentCreated.title': '1 assignment created',
  'aet.toast.assignmentCreated.title.multiple': '{count} assignments created',
  'aet.toast.assignmentCreated.single': 'Assignment was named <b>{assignmentTitle}</b>.',
  'aet.toast.assignmentCreated.multiple': 'Assignment names were also added.',
  'aet.toast.assignmentUpdated.title': 'Har uppdaterats.',
  'aet.toast.assignmentUpdated.title.single': '1 assignment updated',
  'aet.toast.assignmentUpdated.single': 'Your changes have been saved to <b>{assignmentTitle}</b>.',
  'aet.toast.assignmentUpdated.multiple': '{count} uppgifter har uppdaterats',
  'aet.toast.assignmentPublished.single': '{count} assignment published',
  'aet.toast.assignmentPublished.multiple': '{count} assignments published',
  'aet.toast.assignmentPublished.subtitle': 'Uppgiftsinnehåll kan redigeras fram till dess att studenter påbörjar arbetet.',
  'aet.toast.assistedScheduleCreated.single': '{count} Assignment created!',
  'aet.toast.assistedScheduleCreated.multiple': '{count} Assignments created!',
  'aet.toast.assistedScheduleCreated.subtitle': 'Default assignment titles were updated based on content.',
  'aet.toast.assistedSchedulePublished.single': '{count} Assignment published!',
  'aet.toast.assistedSchedulePublished.multiple': '{count} Assignments published!',
  'aet.toast.viewAssignment': 'Visa uppgift',
  'aet.toast.viewAssignments': 'Visa uppgifter',
  'aet.welcome.title': 'Din e-lärobok från Pearson är nu kopplad till din LMS-kurs',
  'aet.welcome.LMSAccounTitle': 'Utforska insikter',
  'aet.welcome.LMSAccounDescription': 'Se exakt vilka ämnen din klass kämpar med.',
  'aet.welcome.createAssignmentsTitle': 'Skapa uppgifter',
  'aet.welcome.createAssignmentsDescription': 'Tilldela kapitel manuellt eller genom att ladda upp kursplanen.',
  'aet.welcome.progressViewTitle': 'Håll koll på resultat i ditt LMS',
  'aet.welcome.progressViewDescription': 'Välj hur betyg ska synkroniseras i din LMS-kurs.',
  'aet.assignmentDetails.noAssignmentFound': 'Inga uppgifter hittades',
  'aet.assignments.loadingErrorTitle': 'Det går inte att ladda uppgiften just nu',
  'aet.assignments.loadingErrorDescription': 'Försök att uppdatera sidan eller kom tillbaka senare.',
  'aet.assignmentStudentDetails.noDataFound': 'Inga data ännu',
  'aet.assignmentStudentDetails.noData': 'No data',
  'aet.studentRoster.noStudentsRegisteredYet': 'Inga studenter registrerade',
  'aet.studentRoster.noStudentsRegisteredYetDescription': 'Studenterna får tillgång till din kurs när de köper e-läroboken.',
  'aet.home.editAssignmentTooltipDisabled': 'Kan inte redigeras: studenten arbetar fortfarande med uppgiften',
  'aet.home.deleteAssignmentTooltipDisabled': 'Kan inte raderas: studenten arbetar fortfarande med uppgiften',
  'aet.home.StudentDetails.questions': 'Frågor',
  'aet.home.StudentDetails.attempts': 'Försök',
  'aet.home.StudentDetails.comprehension': 'Självförtroende',
  'hero.titleInfo.tooltip': 'Titelinformation',
  'aet.home.publishAssignments': 'Publicera alla uppgifter',
  'aet.assignments.saveScheduleAsDraft': 'Spara schema som utkast',
  'aet.assignments.reviewBeforePublishAlert': 'Granska dina uppgifter, och publicera sedan för att göra dem synliga för studenter.',
  'aet.assignments.copiedCoursePublishAlert': 'Lägg till dina kopierade uppgifter och publicera för att göra dem synliga för studenter.',
  'aet.assignments.allSetPublishAlert': 'Är du redo? Publicera dina uppgifter för att göra dem synliga för studenter.',
  'aet.assignments.emptyStateTitle': 'No assignments yet',
  'aet.assignments.emptyStateDescription': 'Assignments you create will appear here',
  'aet.dashboard.footer': 'Visst innehåll har skapats med hjälp av AI baserat på Pearsons läromedel. Även om Pearson har en process för att validera resultatet kan generativ AI fortfarande producera felaktig information om personer, platser eller fakta.',
  'aet.home.bulkEditTitle': 'Redigera flera uppgifter samtidigt',
  'aet.home.bulkEditSubtitle': 'Ändra kursplanen och ladda sedan upp den här igen. Dina uppgifter och inlämningsdatum uppdateras enligt dessa ändringar.',
  'aet.home.createAssignmentTitle': 'Skapa uppgifter',
  'aet.assignments.includedInAnotherAssignmentTooltip': 'Ingår i en annan uppgift',
  'aet.assignments.someSectionsIncludedInAnotherAssignmentTooltip': 'Vissa avsnitt ingår i en annan uppgift',
  'aet.welcome.welcome.Title': 'Välkommen!',
  'aet.home.student.roaster.ProgressTitle': 'Slutfört hittills',
  'aet.assignmentStudentDetails.startAssignmentDescription': 'Kom tillbaka när studenterna har påbörjat uppgiften.',
  'aet.home.whatDueThisWeekTitle': 'Veckans inlämningar',
  'aet.assignments.edit.errorTitle': '{count} uppgifter innehåller fel',
  'aet.assignments.edit.errorSubTitle': 'Det går inte att publicera uppgifter som innehåller fel. Redigera uppgifterna eller publicera utan dem.',
  'aet.assignments.edit.publishAnyway': 'Publicera ändå',
  'aet.assignments.edit.editAssignments': 'Redigera uppgifter',
  'aet.assignments.edit.validationInfoToolTip': 'Redigera uppgiften för att korrigera fel',
  'aet.assignments.error.assignmentCreated.title': 'Alla uppgifter innehåller fel',
  'aet.assignments.error.assignmentCreated.description': 'Det går inte att publicera uppgifter som innehåller fel. Redigera dem eller försök med en annan läroplan.',
  'aet.assignments.error.uploadSyllabus': 'Ladda upp kursplan',
  'aet.assignments.error.editAssignments': 'Redigera uppgifter',
  'aet.mondly.title': 'Språk',
  'aet.studentRoster.errorState.title': 'Studentlistan är inte tillgänglig',
  'aet.studentRoster.errorState.description': 'Det gick inte att ladda din studentlista. Försök att uppdatera sidan eller kom tillbaka senare.',
  'aet.assignments.sectionLabel': 'avsnitt',
  'aet.assignments.sectionLabelCapitalized': 'Section(s):',
  'aet.assignments.sectionsPrefix': 'Sections:',
  'aet.assignments.tags.dueNext': 'Due next',
  'aet.assignments.tags.pastDue': 'Past due',
  'aet.assignments.completionLabel': 'answered',
  'aet.assignments.chaptersPrefix': 'Chapters:',
  'aet.assignments.questionsLabel': 'fråga/frågor',
  'aet.assignments.assignmentsLabel': 'uppgift(er)',
  'aet.assignments.performanceProgressBar': 'Förloppsindindikator för resultat',
  'aet.assignments.completionProgressBar': 'Förloppsindindikator för slutförande',
  'aet.syllabus.deleteConfirmationSubtitleSingle': 'Är du säker på att du vill radera den här uppgiften?',
  'aet.syllabus.deleteConfirmationSubtitleBulk': 'Är du säker på att du vill radera de här uppgifterna?',
  'aet.home.nextAssignmentTitle': 'Nästa uppgift',
  'aet.home.courseSettings': 'Kursinställningar',
  'aet.home.assignmentSettings': 'Assignment settings',
  'aet.home.pearsonETextbookResources': 'Pearson+ e-lärobokresurser',
  'aet.home.etextbookInformation': 'Information om e-läroboken',
  'aet.multiple.deleteAssignmentKeepCTA': 'Behåll uppgift(er)',
  'aet.syllabus.processingText.header': 'Vi organiserar tilldelad läsning för din klass – det tar bara en liten stund.',
  'aet.syllabus.processingText.uploading': 'Laddar upp ditt dokument',
  'aet.syllabus.processingText.activating': 'Aktiverar AI-komponenter',
  'aet.syllabus.processingText.extracting': 'Extraherar läsuppgifter',
  'aet.syllabus.processingText.mapping': 'Mappar mot lärobokens innehåll',
  'aet.syllabus.processingText.finishing': 'Slutför',
  'aet.syllabus.uploadErrorMessage': 'Se till att din PDF- eller .docx-fil är under 10MB och att din internetanslutning är stabil',
  'aet.syllabus.uploadNoAssignmentsMessage': 'Inga läsuppgifter hittade',
  'aet.syllabus.uploadNoAssignmentsDescription': 'Vi kunde inte hämta läsuppgifter från denna fil. Du kan lägga till dem manuellt.',
  'aet.syllabus.uploadFailedRetryCTA': 'Försök igen',
  'aet.syllabus.uploadModal.noAssignments.title': 'Couldn\'t find assignments',
  'aet.syllabus.uploadModal.noAssignments.body1': 'We weren\'t able to find any reading assignments within the uploaded syllabus.',
  'aet.syllabus.uploadModal.noAssignments.body2': 'Kontrollera på nytt att din kursplan innehåller <qualities a syllabus should have for this to work> och försök igen, eller gå vidare till skapande av manuella uppgifter.',
  'aet.syllabus.uploadModal.noAssignments.manualCreationCTA': 'Manuellt skapande',
  'aet.syllabus.uploadModal.noAssignments.backToUploadCTA': 'Back to upload',
  'aet.syllabus.uploadModal.genericFailure.title': 'Något gick fel',
  'aet.syllabus.uploadModal.genericFailure.body1': 'Vi kunde inte ladda upp och behandla kursplanen.',
  'aet.syllabus.uploadModal.genericFailure.body2': 'Kontrollera din anslutning och försök igen, eller gå vidare till skapande av manuella uppgifter.',
  'aet.syllabus.uploadModal.successTotal.title': 'Redo att granska',
  'aet.syllabus.uploadModal.successTotal.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successTotal.body2': 'Make any adjustments, then save or publish when you\'re ready. You can continue making changes before students start working.',
  'aet.syllabus.uploadModal.successPartial.title': 'Redo att granska',
  'aet.syllabus.uploadModal.successPartial.body1': 'We found {count} assignments from your syllabus.',
  'aet.syllabus.uploadModal.successPartial.body2': 'We couldn\'t find exact matches in the eTextbook for every item. Review your assignments to make any adjustments, then save or publish when you\'re ready.',
  'aet.syllabus.uploadModal.reviewAssignmentsCTA': 'Granska uppgifter',
  'aet.syllabus.selectChapterWithQuestions': 'Välj ett kapitel med fråga/frågor.',
  'preferenceSetting.subTitle': 'Dessa inställningar kommer att vara standard för alla studenter i den här kursen.',
  'preferenceSetting.sections.isAIStudyEnabled.label': 'AI-interaktioner',
  'preferenceSetting.sections.isAIStudyEnabled.subLabel': 'Aktivera AI-studieverktyg och AI-sammanfattningar i sökresultaten',
  'preferenceSetting.sections.isStudyPrepEnabled.subLabel': 'Visa studieförberedelser som hör till den här boken',
  'aet.syllabus.footer': 'Skapande av uppgifter drivs av AI',
  'aet.dashboard.footerDialogDeatils': 'Generativ AI används för att skapa uppgiftsfrågor utifrån Pearsons läromedel. Även om Pearson har en process för att verifiera resultatet kan generativ AI fortfarande producera felaktig information om personer, platser eller fakta. AI används också för att dela in innehållet i uppgifter, utifrån den kursplan och/eller det schema som du tillhandahåller.',
  'aet.review.footer': 'Skapad med hjälp av AI',
  'aet.footerCard.dismiss': 'Avvisa',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText1': 'Studieförberedande material är ytterligare ett verktyg som underlättar inlärning genom att tillhandahålla studenter med videor och övningsuppgifter som är anpassade efter denna kurs.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText2': 'Studenter vars åtkomstplan inte omfattar studieförberedande material kan ombes att prenumerera för att kunna fortsätta använda resurser i studieförberedande material.',
  'preferenceSetting.sections.isStudyPrepEnabled.descriptionText3': 'Studenter som redan har köpt studieförberedande material kommer inte påverkas av denna inställning.',
  'preferenceSetting.sections.isStudyPrepEnabled.helpLinkText': 'Läs mer om fördelarna med studieförberedande material',
  'aet.home.viewCourseId': 'Visa kurs-ID',
  'aet.home.copy': 'Kopiera',
  'aet.home.copied': 'Kopierad',
  'aet.home.courseLabel': 'Kurs-ID:',
  'schoolInfoCard.addUniversity': 'Lägg till skola',
  'schoolInfoCard.title': 'Skolinformation',
  'schoolInfoCard.titleV1': 'Berätta för oss om din kurs',
  'schoolInfoCard.cta': 'Komma igång',
  'schoolInfoCard.pickInstitution': 'Välj skola',
  'schoolInfoCard.addUniversityTitle': 'Lägg till din skola',
  'schoolInfoCard.addUniversitySubtitle': 'Om vi vet vilken skola och vilken kurs du läser kan vi rekommendera de mest användbara studiematerialen för dig.',
  'schoolInfoCard.searchPlaceholder': 'Sök efter din skola...',
  'schoolInfoCard.skip': 'Hoppa över detta steg',
  'schoolInfoCard.nextStep': 'Nästa steg',
  'schoolInfoCard.notInList': 'Min skola finns inte i listan',
  'schoolInfoCard.noResults': 'Inga skolor som matchar din sökning hittades',
  'schoolInfoCard.noResultsHeading': 'Kan du inte hitta din skola?',
  'schoolInfoCard.noResultsInstruction': 'Ange det fullständiga namnet nedan',
  'schoolInfoCard.noResultsInputPlaceholder': 'Skolans namn',
  'schoolInfoCard.addInstitutionLabel': 'Lägg till denna skola',
  'aet.assignments.assignmentTitlePlaceholder': 'Ange en titel',
  'aet.assignments.titleValidation.titleRequired': 'Uppgiftens namn är obligatorisk.',
  'aet.assignments.titleValidation.titleTooLong': 'Uppgiftens namn får inte överstiga {0} tecken.',
  'aet.assignments.titleValidation.titleInvalidChar': 'Uppgiftens namn innehåller ogiltiga tecken.',
  'aet.assignments.titleValidation.titleDuplicate': 'Uppgiftens namn finns redan',
  'aet.syllabus.timeZoneLabel': 'Tidszon',
  'aet.review.reviewReadingFromAssignments': 'Gå igenom läsmaterialet från uppgiften',
  'aet.assignments.chaptersLabel': 'kapitel',
  'menu.myAccount.subTitle': 'Din institution finns här',
  'menu.myAccount.subTitleNotAvailable': 'Du kan när som helst lägga till institutionen här.',
  'schoolInfoCard.toastMessage': 'Universitet sparat',
  'aet.review.threeDotMenu.askAI': 'Fråga AI',
  'aet.home.suggestedRemediationSubtitle': 'Titta på relevanta videoklipp och öva för att behärska dina kursämnen.',
  'aet.home.laggedQuestionLabel': 'Markerade frågor',
  'aet.home.correctAnswer': 'Rätt svar',
  'aet.home.incorrectAnswer': 'Det vanligaste felaktiga svaret',
  'aet.home.behaviourTrendsLabel': 'Frågeinsikter',
  'aet.home.strugglingStudentsLabel': 'Studenter som upplever svårigheter',
  'aet.home.patternsInStudensAiLabel': 'AI-användning bland studenter',
  'aet.home.questionLabel': 'Fråga',
  'aet.home.studentAskingSimilarQuestions': 'Studenter som ställer liknande frågor',
  'aet.home.assignmentDifficultQuestions': 'Svåra frågor',
  'aet.home.behaviorTrends': 'Frågeinsikter',
  'aet.home.behaviors': 'Resultatindikatorer',
  'aet.home.mostDifficultTopics': 'De svåraste frågorna',
  'aet.home.commentsFromStudentLabel': 'Kommentarer från studenter',
  'aet.home.disregard': 'Ignorera',
  'aet.home.reportAsInaccurate': 'Rapportera som felaktig',
  'aet.home.Flagged': 'Markerad',
  'aet.home.reportQuestionTitle': 'Rapportera fråga',
  'aet.home.reportQuestionLabel': 'Vad var problemet med den här frågan?',
  'aet.home.showComments': 'Visa kommentarer',
  'aet.home.studentReports': 'studentrapporter',
  'aet.home.placeholderText': 'Förklara...',
  'aet.home.reportQuestion.notRelevant': 'Inte relevant',
  'aet.home.reportQuestion.notCorrect': 'Inte rätt',
  'aet.home.reportQuestion.unsafe': 'Farligt/skadligt',
  'aet.home.reportQuestion.somethingElse': 'Någonting annat',
  'aet.home.StudentDetails.assistedByAI': 'Med hjälp av AI',
  'aet.home.strugglingStudents.emptyStateTitle': 'Inga studenter har problem just nu',
  'aet.home.strugglingStudents.emptyStateDescription': 'Kom tillbaka lite senare.',
  'aet.home.overallStatus.excelling': 'Presterar mycket väl',
  'aet.home.overallStatus.fallingBehind': 'Ligger efter',
  'aet.home.overallStatus.keepingUp': 'I fas',
  'aet.home.showOnlyDifficultQuestionsLabel': 'Visa endast "Svåra frågor"',
  'aet.home.showOnlyStrugglingStudentsLabel': 'Visa endast "Studenter som upplever svårigheter"',
  'aet.home.viewQuestionInAssignment': 'Visa fråga i uppgift',
  'aet.home.insightRisk.incorrectFirstAttempts': 'Felaktiga första försök',
  'aet.home.insightRisk.multipleIncorrectAttempts': 'Flera felaktiga försök',
  'aet.home.insightRisk.lowConfidence': 'Lågt självförtroende',
  'aet.home.insightRisk.mediumConfidence': 'Medelhögt självförtroende',
  'aet.home.insightRisk.lowEngagement': 'Lågt engagemang',
  'aet.home.insightRisk.countOfStudents': '{count} av {total} studenter',
  'aet.home.insightRisk.na': 'Ej tillämpligt',
  'aet.home.strugglingStudentsHereLabel': 'Studenter som upplever svårigheter här',
  'aet.home.insightRisk.didNotAttempt': 'Försökte inte',
  'aet.home.insightRisk.attempted': 'Attempted',
  'aet.courseHeader.assignableEText': 'Assignable eText',
  'aet.courseHeader.lmsIntegration': 'LMS-integration',
  'aet.courseHeader.lmsIntegrationSubLabel': 'Connected to your LMS',
  'aet.instructorCourse.courseForm.institutionNotOfferedError': 'This institution does not offer this product.',
  'aet.unlinkCourse.title': 'Unlink Pearson and [LMS] courses?',
  'aet.unlinkCourse.warning.accessInfoBeforePearson': 'Your Pearson course will be unlinked from your [LMS] course. You can still access the Pearson course by signing into ',
  'aet.unlinkCourse.warning.pearsonLinkLabel': 'Pearson',
  'aet.unlinkCourse.warning.accessInfoAfterPearson': ' with your linked account.',
  'aet.unlinkCourse.warning.relinkInfo': 'If no students are enrolled in the Pearson course you’re unlinking, you can link it again with the same [LMS] course.',
  'aet.unlinkCourse.beforeContinueHeading': 'Before you continue:',
  'aet.unlinkCourse.beforeContinueItem': 'If you link your [LMS] course with a different Pearson course, delete all Pearson grades from your [LMS] gradebook and any areas or modules in your LMS course. Otherwise, your [LMS] course may have duplicate grades.',
  'aet.unlinkCourse.inProgressCta': 'Unlinking...',
  'aet.unlinkCourse.okCta': 'OK',
  'aet.unlinkCourse.success.title': 'Unlink successful',
  'aet.unlinkCourse.success.heading': 'Your course has been unlinked from your LMS',
  'aet.unlinkCourse.success.descriptionBeforePearson': 'You can still access the course by signing into ',
  'aet.unlinkCourse.success.descriptionAfterPearson': ' with your Pearson account.',
  'aet.unlinkCourse.failure.title': 'Couldn\'t unlink course',
  'aet.unlinkCourse.failure.paragraph1': 'Your course couldn\'t be unlinked from your LMS. Wait a few minutes and try again.',
  'aet.unlinkCourse.failure.paragraph2': 'If the problem continues, contact Pearson Support.'
};

export default sv;
